{
  "error": "Hata",
  "help": "Yardım",
  "info": "Bilgiler",
  "success": "Başarılı",
  "warning": "Uyarı"
}
